var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DealList"},_vm._l((_vm.deals),function(item){return _c('DealCard',{key:item.id,attrs:{"deal":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }